import { StyleFieldsRow } from 'Shared/backend/styles/StyleFieldsRow';
import { StoreColourSetting } from 'Shared/backend/settingsPage/ColourSetting';

export function Colour()
{
	return (
		<StyleFieldsRow>
			<ColourFields />
		</StyleFieldsRow>
	);
}


/* The colour on its own, for a caller that names the location itself - see ruleProperties(). */
export function ColourFields()
{
	return (
		<StoreColourSetting field='colour' label='' notes='' />
	);
}
